/* recovered from production bundle — lib/filters */
// @ts-nocheck

const FILTER_OP_MAP = {
  "=": "eq",
  "!=": "ne",
  "<": "lt",
  ">": "gt",
  "<=": "lte",
  ">=": "gte",
  LIKE: "like",
  ILIKE: "ilike",
  "IS NULL": "isNull",
  "IS NOT NULL": "isNotNull",
  eq: "eq",
  ne: "ne",
  lt: "lt",
  gt: "gt",
  lte: "lte",
  gte: "gte",
  like: "like",
  ilike: "ilike",
  isNull: "isNull",
  isNotNull: "isNotNull",
};

export function serializeFilterClause(e) {
  const op = FILTER_OP_MAP[e.op] ?? e.op;
  const n = {
    column: e.column,
    op,
  };
  if (e.op === "IS NULL" || e.op === "IS NOT NULL") {
    return n;
  } else {
    return {
      ...n,
      value: e.value
    };
  }
}
const Zp = {
  table: e => `tables/${encodeURIComponent(e)}/ddl`,
  view: e => `views/${encodeURIComponent(e)}/ddl`,
  routine: e => `routines/${encodeURIComponent(e)}/ddl`,
  trigger: e => `triggers/${encodeURIComponent(e)}/ddl`
};
